module.exports = __webpack_public_path__ + "img/Dantam Bridal 03.9c5b90c3.jpg";